goog.provide("shadow.js.shim.module$react_bootstrap$TabPane$default");
shadow.js.shim.module$react_bootstrap$TabPane$default = shadow.js.require(369, {}).default;
